// extracted by mini-css-extract-plugin
export var link = "styles-module--link--2rQA4";
export var icon = "styles-module--icon--Rnzzt";
export var button = "styles-module--button--LEgIV";
export var transparent = "styles-module--transparent--+3TyG";